import type { ReactNode } from 'react';
import TransitionLink from '../client/TransitionLink';
import Icon from '../../miniapp/ui-kit/Icon';
import { cn } from '../../miniapp/ui-kit/cn';

export default function ContentLink({
  href,
  children,
  primary = false,
  className,
}: {
  href: string;
  children: ReactNode;
  primary?: boolean;
  className?: string;
}) {
  const classes = cn(
    'inline-flex min-h-12 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-focus-ring',
    primary ? 'bg-accent text-on-accent hover:bg-accent/90' : 'text-accent hover:bg-secondary',
    className,
  );
  const content = (
    <>
      {children}
      <Icon name="arrow_forward" className="shrink-0 text-lg" />
    </>
  );
  return /^(https:|mailto:|tel:|#)/.test(href) ? (
    <a href={href} className={classes}>
      {content}
    </a>
  ) : (
    <TransitionLink to={href} className={classes}>
      {content}
    </TransitionLink>
  );
}
